import * as ACTION_TYPES from './types';

const initState = -1;

export default function reducer(state = initState, action) {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.CONVERSATION_ACTIVE_CONVERSATION:
      return payload.groupId;
    case ACTION_TYPES.CONVERSATION_ACTIVE_CLEAR_CONVERSATION:
      return initState;
    default:
      return state;
  }
}
